import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import ManagementPage from "@/pages/ManagementPage";
import PromotionPage from "@/pages/PromotionPage";
import PublicWidget from "@/pages/PublicWidget";
import NewsPage from "@/pages/NewsPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import EmbedWidget from "@/pages/EmbedWidget";
import EmbedCode from "@/pages/EmbedCode";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ReleaseForm from "@/pages/ReleaseForm";
import ReleaseDetail from "@/pages/ReleaseDetail";
import ShopPage from "@/pages/ShopPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CartPage from "@/pages/CartPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import HugRedirect from "@/pages/HugRedirect";
import TribeRedirect from "@/pages/TribeRedirect";

function App() {
  return (
    <div className="App noise-overlay">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/management" element={<ManagementPage />} />
          <Route path="/promotion" element={<PromotionPage />} />
          <Route path="/recordings" element={<PublicWidget />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/shop/product/:productId" element={<ProductDetailPage />} />
          <Route path="/shop/cart" element={<CartPage />} />
          <Route path="/shop/success" element={<CheckoutSuccessPage />} />
          <Route path="/embed" element={<EmbedWidget />} />
          <Route path="/embed-code" element={<EmbedCode />} />
          <Route path="/release/:id" element={<ReleaseDetail />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/release/new" element={<ReleaseForm />} />
          <Route path="/admin/release/:id" element={<ReleaseForm />} />
          {/* Redirect routes for other Underplay apps */}
          <Route path="/hug" element={<HugRedirect />} />
          <Route path="/tribe" element={<TribeRedirect />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;
